import type { BoostedSummaryParams } from "./types";

export function normalizeDateOnly(value: string) {
  return value.includes("T") ? value.split("T")[0] : value;
}

export function normalizeAdAccountId(value: string | null | undefined) {
  if (!value) {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const id = trimmed.replace(/^act_/i, "").trim();
  return id ? `act_${id}` : null;
}

export function normalizeProfileIds(values: string[] | undefined) {
  if (!values?.length) {
    return;
  }

  const profileIds = values.map((value) => value.trim()).filter(Boolean);
  if (profileIds.length === 0) {
    return;
  }

  return [...new Set(profileIds)].toSorted();
}

export function normalizeBoostedSummaryParams(
  params: BoostedSummaryParams
): BoostedSummaryParams {
  return {
    ...params,
    adAccountId: normalizeAdAccountId(params.adAccountId),
    profileIds: normalizeProfileIds(params.profileIds),
    since: normalizeDateOnly(params.since),
    until: normalizeDateOnly(params.until),
  };
}
